"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _find = _interopRequireDefault(require("lodash/find"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _isObject = _interopRequireDefault(require("lodash/isObject"));
var _map = _interopRequireDefault(require("lodash/map"));
var _some = _interopRequireDefault(require("lodash/some"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TableHeading = _interopRequireDefault(require("./TableHeading"));
var _TableCell = _interopRequireDefault(require("./TableCell"));
var _TableFooter = _interopRequireDefault(require("./TableFooter"));
var _TableSortSelector = _interopRequireDefault(require("./TableSortSelector"));
var _TableSortType = _interopRequireDefault(require("./TableSortType"));
var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(0, _deprecate.default)({
  name: 'Table',
  newName: 'Table',
  changes: ['---- Props ----', 'In order to accomplish the same functionality as using `footerMessage`, now use the `<Tfoot />` component in the table structure instead of passing in as a prop', 'Pagination and Sorting are not yet supported in the v2 Table component', '---- Changes in v2 component  ----', 'New v2 Table component is now a paired-down in functionality compaired to v1 version', '`containerClassName`, `headers`, `data`, `currentPage`, `sortOrder`, `sortDataKey`, `totalDataRowCount`, `rowSize`, `showFooterMessage`, `footerMessage`, `pageSize`, `sorting`, `onPageChange`, `onSortChange`, and `noDataAvailableMessage` are not yet supported in the v2 Table component', '---- Additional Information ----', 'new props are documented at: https://chakra-ui.com/docs/data-display/table']
});
class Table extends _react.Component {
  static defaultProps = {
    currentPage: 1,
    totalDataRowCount: 0,
    rowSize: 'normal',
    pageSize: 25,
    noDataAvailableMessage: 'No data available at this time.',
    showFooterMessage: true
  };
  constructor(props) {
    super(props);
    const {
      headers,
      currentPage,
      totalDataRowCount,
      pageSize,
      sortOrder,
      sortDataKey
    } = props;
    this._HEADERS = headers;
    this.state = {
      sortOrder,
      sortDataKey,
      currentPage,
      totalPages: Math.ceil(totalDataRowCount / pageSize)
    };
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      onPageChange,
      onSortChange,
      totalDataRowCount,
      pageSize
    } = this.props;
    const {
      currentPage: previousCurrentPage,
      sortOrder: previousSortOrder,
      sortDataKey: previousSortDataKey
    } = prevState;
    const {
      totalPages,
      currentPage,
      sortOrder,
      sortDataKey
    } = this.state;
    if (totalDataRowCount !== prevProps.totalDataRowCount || pageSize !== prevProps.pageSize) {
      this.setState({
        totalPages: Math.ceil(totalDataRowCount / pageSize)
      });
    }
    if (previousCurrentPage !== currentPage && onPageChange) {
      onPageChange({
        totalPages,
        currentPage,
        previousPage: previousCurrentPage
      });
    }
    if ((previousSortOrder !== sortOrder || previousSortDataKey !== sortDataKey) && onSortChange) {
      onSortChange({
        sortOrder,
        dataKey: sortDataKey
      });
    }
  }
  _onPageChange = ({
    value
  }) => {
    this.setState({
      currentPage: parseInt(value, 10)
    });
  };
  _onPreviousPage = evt => {
    this.setState((prevState, props) => {
      return {
        currentPage: prevState.currentPage - 1
      };
    });
  };
  _onNextPage = evt => {
    this.setState((prevState, props) => {
      return {
        currentPage: prevState.currentPage + 1
      };
    });
  };
  _onSortChange = ({
    dataKey,
    sortOrder
  }) => {
    this.setState({
      sortOrder,
      sortDataKey: dataKey
    });
  };
  _renderHeadings = () => {
    const {
      sortOrder,
      sortDataKey
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("thead", {
      className: "TableHead"
    }, /*#__PURE__*/_react.default.createElement("tr", null, this._HEADERS.map(header => {
      const {
        render,
        ...headerProps
      } = header;
      const {
        dataKey,
        isSortable
      } = headerProps;
      const Heading = render ? render : _TableHeading.default;
      if (isSortable) {
        headerProps.onSortClick = this._onSortChange;
        headerProps.sortOrder = dataKey === sortDataKey ? sortOrder : null;
      }
      return /*#__PURE__*/_react.default.createElement(Heading, (0, _extends2.default)({
        key: dataKey
      }, headerProps));
    })));
  };
  _renderRows = () => {
    const {
      data,
      sorting,
      noDataAvailableMessage
    } = this.props;
    if (!data.length) {
      return /*#__PURE__*/_react.default.createElement("tbody", {
        className: "TableBody Table-no-data"
      }, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: this._HEADERS.length
      }, /*#__PURE__*/_react.default.createElement("div", null, noDataAvailableMessage))));
    }
    let sortedData = data;
    if (sorting) {
      const sort = (0, _isFunction.default)(sorting) ? [sorting] : [...sorting];
      sortedData = (0, _sortBy.default)(data, sort);
    }
    return /*#__PURE__*/_react.default.createElement("tbody", {
      className: "TableBody"
    }, sortedData.map(({
      className: rowClass,
      ...row
    }, i) => {
      if (row.customRowRender) {
        return row.customRowRender({
          key: i,
          row
        });
      } else {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: i,
          className: rowClass
        }, (0, _map.default)(row, (cell, dataKey) => {
          const {
            className,
            value
          } = cell;
          const Cell = (0, _isObject.default)(cell) && cell.render ? cell.render : _TableCell.default;
          const key = `${i}-${dataKey}`;
          const label = (0, _find.default)(this._HEADERS, {
            dataKey
          }).label;
          const cellValue = (0, _isObject.default)(cell) ? value : cell;
          return /*#__PURE__*/_react.default.createElement(Cell, {
            key: key,
            className: className,
            headingLabel: label,
            value: cellValue
          });
        }));
      }
    }));
  };
  _renderFooter = () => {
    const {
      rowSize,
      pageSize,
      data,
      totalDataRowCount,
      showFooterMessage,
      footerMessage
    } = this.props;
    const {
      currentPage,
      totalPages
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_TableFooter.default, {
      rowSize: rowSize,
      pageSize: pageSize,
      totalDataRowCount: totalDataRowCount,
      currentPage: currentPage,
      totalPages: totalPages,
      currentPageLength: data.length,
      showMessage: showFooterMessage,
      message: footerMessage,
      onPageChange: this._onPageChange,
      onPreviousPage: this._onPreviousPage,
      onNextPage: this._onNextPage
    });
  };
  _renderTableSortDropdown = () => {
    const {
      sortOrder,
      sortDataKey
    } = this.state;
    const hasSortableHeaders = (0, _some.default)(this._HEADERS, 'isSortable');
    if (!hasSortableHeaders) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_TableSortSelector.default, {
      headers: this._HEADERS,
      sortOrder: sortOrder,
      sortDataKey: sortDataKey,
      onSortChange: this._onSortChange
    });
  };
  render() {
    const {
      containerClassName,
      className,
      rowSize
    } = this.props;
    const containerClasses = (0, _classnames.default)('Table-container', containerClassName);
    const tableClasses = (0, _classnames.default)('Table', {
      'Table-large': rowSize === 'large'
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: containerClasses
    }, this._renderTableSortDropdown(), /*#__PURE__*/_react.default.createElement("table", {
      className: tableClasses
    }, this._renderHeadings(), this._renderRows()), this._renderFooter());
  }
}
exports.default = Table;